import { toPence } from './LineItemsTable';

export const CIS_RATES = [
  { value: 20, label: '20%', hint: 'Standard — registered sub-contractor' },
  { value: 30, label: '30%', hint: 'Higher — not registered / unverified' },
  { value: 0, label: 'Gross', hint: 'Gross payment status — no deduction' },
];
export const VAT_TREATMENTS = [
  { value: 'no_vat', label: 'No VAT / not registered' },
  { value: 'reverse_charge', label: 'Domestic reverse charge 0%' },
];
export const CIS_CATEGORIES = ['labour', 'material', 'fuel'];
export const CIS_DEDUCTIBLE = ['labour']; // fuel is exempt like materials (owner, 17/10/2026)

export const defaultCis = (it) => ({
  enabled: !!it?.cis?.enabled,
  rate: it?.cis?.rate ?? 20,
  vat_treatment: it?.cis?.vat_treatment || 'no_vat',
  source: it?.cis?.source || null,
  user_set: !!it?.cis?.user_set,
});

export const rateLabel = (rate) => (Number(rate) === 0 ? 'Gross status (0%)' : `${Number(rate)}% deduction`);

/** Mirror of the server's cis_workings: labour / materials / fuel split, deduction on labour + fuel. */
export function cisWorkings(lines, rate) {
  const by = { labour: 0, material: 0, fuel: 0, other: 0 };
  for (const l of lines || []) {
    const cat = by[l.category] !== undefined ? l.category : 'other';
    by[cat] += toPence(l.amount ?? (l.value_pence != null ? l.value_pence / 100 : 0));
  }
  const base = CIS_DEDUCTIBLE.reduce((s, c) => s + by[c], 0);
  const net = by.labour + by.material + by.fuel + by.other;
  const deduction = Math.round((base * Number(rate || 0)) / 100);
  return { ...by, base, net, deduction, payable: net - deduction, rate: Number(rate || 0) };
}
